<template>
  <aside class="menu menu--sidebar">
    <ul class="menu-list">
      <template v-for="navigation in navigations">
        <template v-if="navigation.pages && navigation.pages.length > 0">
          <li>
            <span :class="{ 'is-active': activeLink === navigation.url }">
              <el-popover
                placement="right"
                trigger="hover"
                width="200">
                <aside class="menu">
                  <p class="menu-label">{{ $t(navigation.label) }}</p>
                  <ul class="menu-list">
                    <li v-for="(page, childIndex) in navigation.pages" :key="page.url">
                      <router-link
                         tag="a"
                         activeClass="is-active"
                        :to="{ name: page.name }">
                        <span class="text">{{ $t(page.label) }}</span>
                      </router-link>
                    </li>
                  </ul>
                </aside>
                <nuttrema-iconica-sidebar-link
                   slot="reference"
                  :icon="navigation.navigationIcon"
                  :text="$t(navigation.label)"
                  @mouseenter="$emit('mouseenter')"
                  @click="$emit('click')">
                </nuttrema-iconica-sidebar-link>
              </el-popover>
            </span>
          </li>
        </template>
        <template v-else>
          <li>
            <router-link
               tag="a"
              :class="{ 'is-active': $route.name === navigation.name }"
              :to="{ name: navigation.name }">
              <nuttrema-iconica-sidebar-link
                :icon="navigation.navigationIcon"
                :text="$t(navigation.label)">
              </nuttrema-iconica-sidebar-link>
            </router-link>
          </li>
        </template>
      </template>
    </ul>
  </aside>
</template>

<script>
import { flow, sortBy, last } from 'lodash';
import { filterPagesByAttributes } from 'utils';
import { NavigationsPublic } from 'data';

import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'sidebar-menu-level-auth-collapsed',
  components: {
    NuttremaIconicaSidebarLink,
  },
  data() {
    return {
      activeLink: null,
    };
  },
  computed: {
    navigations() {
      const result = [];
      const auth = this.$auth;
      filterPagesByAttributes(el => (el.scope ? (auth.check(el.scope)) : true), NavigationsPublic, result);
      return result;
    },
  },
  methods: {
    handleOpen() {},
    handleClose() {},
    getActiveLink() {
      const link = flow(sortBy(n => n.path.length), last)(this.$route.matched);
      this.activeLink = link.path !== '' ? link.path : '/';
      const count = (link.path.match(new RegExp('/', 'g')) || []).length;
      if (count > 2) {
        const parts = link.path.split('/');
        this.activeLink = `/${parts[1]}`;
      }
    },
  },
  created() {
    this.getActiveLink();
  },
  watch: {
    $route() {
      this.getActiveLink();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/menu/auth/sidebar-menu-level-auth-collapsed.vue